import { Button } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import * as XLSX from 'xlsx';
import { getItemPOList, getItemPRList } from "../../api";
import { setBreadcrumbItems } from "../../store/actions";
import Table from "../DummyTable/Table";
import "./styles/reports.scss";
import DateFilter from "../../components/CustomComponents/DateFilter";
import { toast } from "react-toastify";
import StyledButton from "../../components/Common/StyledButton";

const defaultPageSize = 10;

const getColumns = () => {
    return [
      {
        accessorKey: "itemName",
        header: () => <span>Item Name</span>,
        enableSorting: true,
        cell: value => <span>{value.getValue()}</span>
      },
      {
        accessorKey: "itemDescription",
        header: () => <span>Description</span>,
        cell: value => <span>{value.getValue() || "-"}</span>
      },
      {
        accessorKey: "hsnCode",
        header: () => <span>HSN Code</span>,
        cell: value => <span>{value.getValue()}</span>
      },
      {
        accessorKey: "itemUnit",
        header: () => <span>Unit</span>,
        cell: value => <span>{value.getValue()}</span>
      },
      {
        accessorKey: "totalQuantity",
        header: () => <span>Total Qty</span>,
        enableSorting: true,
        cell: value => <span>{value.getValue()}</span>
      },
      {
        accessorKey: "totalAmount",
        header: () => <span>Subtotal</span>,
        enableSorting: true,
        cell: value => <span>{value.getValue()}</span>
      },
      {
        accessorKey: "totalTax",
        header: () => <span>GST</span>,
        enableSorting: true,
        cell: value => <span>{value.getValue()}</span>
      },
      {
        accessorKey: "grandTotal",
        header: () => <span>Total</span>,
        enableSorting: true,
        cell: value => (
          <span style={{ fontWeight: 600 }}>
            {value.getValue()}
          </span>
        )
      }
    ];
  };

const ByPRPO = (props) => {
    const { reportType, userType } = props;
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: defaultPageSize });
    const [total, setTotal] = useState(0);
    const [rows, setRows] = useState([]);

    const [date, setDate] = useState(null);
    const [isExporting, setExporting] = useState(false);

    const effectCalled = useRef(false);

    const breadcrumbItems = reportType === 'PO' ? [
        { title: "Dashboard", link: "/dashboard" },
        { title: "By Item PO", link: "#" },
    ] : [
      { title: "Dashboard", link: "/dashboard" },
      { title: "By Item PR", link: "#" },
  ];

  useEffect(() => {
    if (!effectCalled.current) {
      props.setBreadcrumbItems(reportType === 'PO' ? 'By Item PO' : 'By Item PR', breadcrumbItems);
      effectCalled.current = true;
    }
  }, []);

  const getItemPRPOList = async (page, limit) => {
    const body = {
      page,
      limit,
      sortField: sorting.id,
      sortOrder: sorting.desc ? 'desc' : 'asc',
      clientId: userType === 'client' ? JSON.parse(localStorage.getItem('user')).clientId : '',
    };

    if (date) {
      body.startDate = date.start;
      body.endDate = date.end;
    }
    const res = reportType === 'PO' ? await getItemPOList(body) : await getItemPRList(body);

    return res;
  }

  useEffect(() => {
    const fetchList = async () => {
      try {
        const res = await getItemPRPOList(pagination.pageIndex + 1, pagination.pageSize);
        if (res.success) {
          const { page, limit, totalCount, data} = res.payload;
          setRows(data);
          setTotal(totalCount);
        }
      } catch (err) {
        console.error('Error fetching module list:', err);
      }
    };
    fetchList();
  }, [pagination, sorting, date]);

  const columns = useMemo(() => getColumns(reportType, userType), [reportType]);

  const resetPagination = () => {
    setPagination({
      pageIndex: 0,
      pageSize: defaultPageSize,
    });
  }

  const resetFilters = () => {
    setDate(null);
    resetPagination();
  }

  const onDateChange = (data) => {
    setDate(data);
  };

  const downloadItemsExcel = async () => {
    try {
      setExporting(true);
      const response = await getItemPRPOList();
  
      console.log(response);
      if (response.success) {
        const { data } = response.payload;
  
        const flatItems = data.map(ele => ({
          "Item Name": ele.itemName || '-',
          "Item Description": ele.itemDescription || '-',
          
          "HSN": ele.hsnCode || '-',
          "Unit": ele.itemUnit || '-',
          "Total Quantity": ele.totalQuantity || '-',
          "Total Amount": ele.totalAmount || '-',
          "Total Tax": ele.totalTax || '-',
          "Grand Total ": ele.grandTotal || '-',
        }));

        // Convert to worksheet
        const worksheet = XLSX.utils.json_to_sheet(flatItems);
  
        // Create workbook and add worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'PR_PO');
  
        // Download as Excel file
        XLSX.writeFile(workbook, reportType === 'PO' ? 'PO-Item-List.xlsx' : 'PR-Item-List.xlsx');
        toast.success('Item(s) Exported Successfully!');
        setExporting(false);
      } else {
        console.error('Failed to fetch Item(s)');
        setExporting(false);
      }
    } catch (error) {
      console.error('Error downloading Excel:', error);
      setExporting(false);
    }
};

  return (
    <div>
      <div className="filter-wrapper">
        <DateFilter
          onDateChange={onDateChange}
        />
        <Button variant="outlined" onClick={resetFilters}>Reset</Button>
        <div>
                    <StyledButton
                        color={"primary"}
                        className={"w-md"}
                        onClick={downloadItemsExcel}
                        isLoading={isExporting}
                    >
                      <div>
                        <i className="ion ion-md-cloud-download mx-2"></i>
                        Export
                      </div>
                    </StyledButton>
                    </div>
      </div>
      <Table
        data={rows}
        columns={columns}
        manualPagination
        rowCount={total}
        sorting={sorting}
        pagination={pagination}
        setSorting={setSorting}
        setPagination={setPagination}
      />
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(ByPRPO);